import { FEATURES } from 'Context/FeaturesContext/FeaturesContextConsts';
import { MIRAGE_SCENARIOS } from 'Mirage/scenarios/scenarios.consts';

import styles from './SaleTimeControllerWarningMessage.module.scss';

interface FeatureToggleTextProps {
	text: string;
}

const FeatureToggleText: React.FC<FeatureToggleTextProps> = ({ text }) => (
	<code>
		<span className={styles.featureToggleText}>{text}</span>
	</code>
);

export const SaleTimeControllerWarningMessage: React.FC = () => (
	<>
		<h2 className={styles.saleTimeControllerWarningTitle}>Sale Time Controller</h2>
		<p>
			To enable the Sale Time Controller please turn on the
			<FeatureToggleText text={FEATURES.mirageServer} />
			feature toggle.
		</p>
		<p>
			If you would like to simulate different sale times, use the
			<FeatureToggleText text={MIRAGE_SCENARIOS.SIMULATE_SALE_TIMES} />
			Mirage scenario.
		</p>
		<br />
	</>
);
